import { render } from "./Witch.vue?vue&type=template&id=87b9d008&scoped=true&ts=true"
import script from "./Witch.vue?vue&type=script&lang=ts"
export * from "./Witch.vue?vue&type=script&lang=ts"

import "./Witch.vue?vue&type=style&index=0&id=87b9d008&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b9d008"]])

export default __exports__